import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { AdminPanelNavCard } from './components/admin-panel-nav-card/admin-panel-nav-card';
import { APP_PATHS } from '../../../core/config/app-paths';
import { Router } from '@angular/router';

type NavItem = {
  label: string;
  icon: string;
  route: string;
};

@Component({
  selector: 'app-admin-panel-home',
  imports: [AdminPanelNavCard],
  templateUrl: './admin-panel-home.html',
  styleUrl: './admin-panel-home.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelHome {
  #router = inject(Router);

  protected readonly menuItems = computed<NavItem[]>(() => {
    return [
      {
        label: 'Zarządzanie wnioskami',
        icon: 'applications',
        route: APP_PATHS.admin.applications,
      },
      {
        label: 'Zarządzanie użytkownikami',
        icon: 'users',
        route: APP_PATHS.admin.users,
      },
      {
        label: 'Zarządzanie komunikatami',
        icon: 'announcements',
        route: APP_PATHS.admin.announcements,
      },
      {
        label: 'Zarządzanie regulaminem',
        icon: 'rules',
        route: APP_PATHS.admin.rules,
      },
      {
        label: 'Raporty',
        icon: 'reports',
        route: APP_PATHS.admin.reports,
      },
    ];
  });
  protected nagivateToView(route: string): void {
    this.#router.navigate([APP_PATHS.admin.root, route]);
  }
}
